import { render } from "./ConnectionTable.vue?vue&type=template&id=136c87c9"
import script from "./ConnectionTable.vue?vue&type=script&lang=js"
export * from "./ConnectionTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__